<div
  class="card-form-group-container"
  [formGroup]="form">
  <ng-container [ngSwitch]="context?.TSK">
    <app-input-vocabulary-autocomplete
      *ngSwitchCase="'OA'"
      formControlName="OGTD"
      [vocabularyName]="'V_OA_OGTD'"
      [placeholder]="'Definizione oggetto (OGTD)'">
    </app-input-vocabulary-autocomplete>
    <app-input-vocabulary-autocomplete
      *ngSwitchCase="'F'"
      formControlName="OGTD"
      [vocabularyName]="'V_F_OGTD'"
      [placeholder]="'Definizione oggetto (OGTD)'">
    </app-input-vocabulary-autocomplete>
    <mat-form-field *ngSwitchDefault>
      <input
        matInput
        placeholder="Definizione oggetto (OGTD)"
        formControlName="OGTD">
    </mat-form-field>
  </ng-container>
</div>
